import { h } from 'preact'
import { replaceFilter, replaceCleaner, tagParser } from '../../js/modules/utilities.js'
import { attributesAnalytics } from '../../js/modules/component'

export const Menu = ({ title, items, cacheKey, hasMobileDirectLinks }) => {
   return (
      <div class="container-fluid" data-testid="bande-menu-n-2">
         {title !== '' ? <h2>{title}</h2> : ''}

         <nav id="zone_menu-n-2">
            <ul class={`menu-n-1 mb-2 ${hasMobileDirectLinks === true ? 'd-none d-lg-flex' : ''}`} data-cache-key={cacheKey}>
               {items.map((item, index) => {
                  return (
                     <li
                        class="menu-link"
                        data-testid={`menu-n-2-${index}`}
                        {...attributesAnalytics(item.analytics)}
                     >
                        <a href={item.URL}>
                           <img loading="lazy" class="hpicon" src={`${item.image}?format=x92`} alt="" />
                           <span class="o-link-arrow o-link-small title" dangerouslySetInnerHTML={{ __html: tagParser(replaceFilter(item.title)) }}></span>
                        </a>
                     </li>
                  )
               })}
            </ul>

            {hasMobileDirectLinks === true ? (
               <div class="row mb-2 d-lg-none">
                  <ul class="items-list m-0 row liens-directs">
                     {items.map((item) => {
                        return (
                           <li class="col-12 col-sm-6">
                              <a
                                 href={item.URL}
                                 class="items-list-item"
                                 target={item.target}
                                 {...attributesAnalytics(item.analytics)}
                              >
                                 <span class="item-icon" aria-hidden="true">
                                    <img loading="lazy" src={`${item.image}?format=100x100`} alt="" width="50" height="50" />
                                 </span>
                                 <div class="item-container">
                                    <div class="item-text">
                                       <span class="item-title" dangerouslySetInnerHTML={{ __html: tagParser(replaceCleaner(item.title), true) }}></span>
                                       {item.description && item.description !== '' ? <small class="item-desc">{item.description}</small> : null}
                                    </div>
                                 </div>
                              </a>
                           </li>
                        )
                     })}
                  </ul>
               </div>
            ) : (
               ''
            )}
         </nav>
      </div>
   )
}
